import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ValuationExhausted: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleContactUs = () => {
    // You can replace this with your actual contact information
    window.open('https://wa.link/m2zn1t', '_blank');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#9600ff] p-4">
      {/* User Info Header */}
      {currentUser && (
        <div className="absolute top-4 right-4 flex items-center space-x-4">
          <div className="flex items-center space-x-2 bg-white/10 rounded-lg px-3 py-2">
            {currentUser.photoURL && (
              <img 
                src={currentUser.photoURL} 
                alt="Profile" 
                className="w-6 h-6 rounded-full"
              />
            )}
            <span className="text-sm font-medium">{currentUser.displayName || currentUser.email}</span>
          </div>
          <button
            onClick={handleLogout}
            className="bg-white/10 hover:bg-white/20 text-white px-3 py-2 rounded-lg text-sm transition-all"
          >
            Logout
          </button>
        </div>
      )}
      
      <div className="w-full max-w-2xl mx-auto p-8 bg-white/10 rounded-2xl text-white text-center backdrop-blur-md">
        <div className="mb-8">
          <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold mb-4">Valuation Limit Reached</h1>
          <p className="text-lg opacity-90 mb-6">
            You have exhausted your free valuation. For comprehensive, professional valuations and detailed analysis, please contact our team.
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <div className="bg-white/10 rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-3">What's Included in Professional Valuation:</h3>
            <ul className="text-left space-y-2 opacity-90">
              <li className="flex items-center">
                <span className="text-green-400 mr-2">✓</span>
                Detailed financial analysis
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-2">✓</span>
                Market comparison studies
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-2">✓</span>
                Growth projections
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-2">✓</span>
                Investment recommendations
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-2">✓</span>
                One-on-one consultation
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleContactUs}
            className="bg-white text-black font-bold py-3 px-8 rounded-lg hover:bg-opacity-90 transition-all"
          >
            Contact Us
          </button>
          <button
            onClick={() => navigate('/')}
            className="bg-white/10 text-white font-bold py-3 px-8 rounded-lg hover:bg-white/20 transition-all"
          >
            Back to Home
          </button>
        </div>

        <p className="text-xs opacity-60 mt-6">
          Need multiple valuations? Contact us for enterprise solutions.
        </p>
      </div>
    </div>
  );
};

export default ValuationExhausted; 